module.exports = __webpack_public_path__ + "static/media/edit2.8cfed2fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/edit2.svg
// module id = 840
// module chunks = 21